// FAQs for the e-commerce development service page (also used for its FAQ JSON-LD).
const ecommerceFaqs = [
  {
    q: "How much does an e-commerce website cost?",
    a: "It depends on the number of products, features, integrations (payment, shipping, ERP) and the platform you choose. Share your requirements and we will send a clear, itemised estimate.",
  },
  {
    q: "How long does it take to build an online store?",
    a: "A standard store usually takes 4–8 weeks. Larger stores with custom features, integrations or marketplaces can take longer depending on scope and feedback.",
  },
  {
    q: "Which platform is best for my store?",
    a: "Shopify suits fast launches, WooCommerce suits WordPress users, Magento suits large catalogues, and a custom build suits unique workflows. We recommend one after understanding your business.",
  },
  {
    q: "Can you integrate payment gateways?",
    a: "Yes. We integrate popular gateways such as Razorpay, PayU, Stripe and PayPal, along with UPI, cards, wallets and cash on delivery.",
  },
  {
    q: "Will my store work well on mobile?",
    a: "Yes. Every store we build is fully responsive and optimised for fast, smooth shopping on phones, tablets and desktops.",
  },
  {
    q: "Can I manage products and orders myself?",
    a: "Yes. You get an easy admin panel to add products, update prices and stock, manage orders, run offers and view reports without a developer.",
  },
  {
    q: "Do you help with SEO for e-commerce?",
    a: "Yes. We build with SEO-friendly structure, fast loading, clean URLs, product schema and meta tags so your products can rank better in search.",
  },
  {
    q: "Do you provide support after launch?",
    a: "Yes. We offer maintenance plans covering updates, security, backups, performance monitoring and new features as your store grows.",
  },
];

export default ecommerceFaqs;
